import React, { memo } from 'react';

import { Box } from '@mui/material';

import { pagesPropTypes } from '../../MainContent.constants';

import Counseling from './Counseling';
import { declarationsPageStyles } from './Declarations.styles';
import Demographic from './Demographic';
import Finances from './Finances';
import HomeownershipEducationAndHousingCounseling from './HomeownershipEducationAndHousingCounseling';
import LanguagePreference from './LanguagePreference';
import MilitaryServices from './MilitaryServices';
import PropertyAndLoan from './PropertyAndLoan';

const Declarations = ({ className, ...sectionProps }) => (
  <Box className={className} sx={declarationsPageStyles}>
    <PropertyAndLoan {...sectionProps} />
    <Finances {...sectionProps} />
    <MilitaryServices {...sectionProps} />
    <HomeownershipEducationAndHousingCounseling {...sectionProps} />
    <LanguagePreference {...sectionProps} />
    <Demographic {...sectionProps} />
    <Counseling {...sectionProps} />
  </Box>
);

Declarations.propTypes = pagesPropTypes;

export default memo(Declarations);
